import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useIntl } from 'react-intl';
import Link from '../../../components/Link';
import { typeToSlug } from './emailTemplateSlug';
import { getEmailTemplatesList } from '../../../lib/graphql';
import CustomPagination from '../../../components/CustomPagination/CustomPagination';
import CommonTable from '../../../components/CommonTable/CommonTable';
import messages from '../../../locale/jsonMessages';
import debounce from '../../../helpers/debounce';
import bt from '../../../components/commonStyle.css';


const PAGE_SIZE = 10;

function EmailTemplates(props) {
  const [displaySearchKey, setDisplaySearchKey] = useState('');
  const [searchKey, setSearchKey] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const intl = useIntl();

  const { data, previousData, loading, refetch } = useQuery(getEmailTemplatesList, {
    variables: {
      searchKey: searchKey || '',
      currentPage
    },
    fetchPolicy: 'network-only',
    ssr: false,
    notifyOnNetworkStatusChange: true
  });

  const resolvedData = data ?? previousData;
  const list = resolvedData?.getEmailTemplatesList?.results ?? [];
  const count = resolvedData?.getEmailTemplatesList?.count ?? 0;


  const handleSearchChange = debounce((value) => {
    setDisplaySearchKey(value || '');
    setSearchKey(value || '');
    setCurrentPage(1);
    refetch({ currentPage: 1, searchKey: value })
  }, 500);

  const paginationData = useCallback(
    (page) => {
      setCurrentPage(page);
    },
    []
  );

  const thead = useCallback(
    () => [
      { data: intl.formatMessage(messages.transferType) },
      { data: intl.formatMessage(messages.emailTemplateTableSubject) },
      { data: intl.formatMessage(messages.emailTemplatePreviewTextLabel) },
      { data: intl.formatMessage(messages.editLabel) }
    ],
    [intl]
  );

  const tbody = useCallback(
    () =>
      list.map((row) => ({
        id: row.type,
        data: [
          { data: row.type || '—' },
          { data: row.subject || '—' },
          { data: row.previewText || '—' },
          {
            data: (
              <div>
                <Link to={`/siteadmin/email-templates/edit/${typeToSlug(row.type)}`}>
                  {intl.formatMessage(messages.editLabel)}
                </Link>
              </div>

            )
          }
        ]
      })),
    [list, intl]
  );


  return (
    <div>
      <h1 className={'siteAdminHeading'}>
        {intl.formatMessage(messages.emailTemplateListLabel)}
      </h1>
      <p className={bt.commonMediumText}>
        {intl.formatMessage(messages.emailTemplateListDescription)}
      </p>
      <CommonTable
        thead={thead}
        tbody={tbody}
        isSearch
        onSearch={(e) => handleSearchChange(e?.target?.value)}
      />
      {count > 0 && (
        <CustomPagination
          total={count}
          currentPage={currentPage}
          defaultCurrent={1}
          defaultPageSize={PAGE_SIZE}
          change={paginationData}
          paginationLabel="templates"
          isScroll
        />
      )}
    </div>
  );
}

EmailTemplates.propTypes = {
  title: PropTypes.string.isRequired
};

export default withStyles(bt)(EmailTemplates);
